export const base64ToUrl = (data: string) =>
  data.replace(/\//g, '_').replace(/\+/g, '-');

export const urlToBase64 = (data: string) =>
  data.replace(/_/g, '/').replace(/-/g, '+');

export const uint8ArrayToBase64 = (data: Uint8Array) =>
  // eslint-disable-next-line deprecation/deprecation
  btoa(String.fromCharCode.apply(null, Array.from(data)));

export const base64ToUint8Array = (data: string) =>
  // eslint-disable-next-line deprecation/deprecation
  atob(data)
    .split('')
    .reduce((acc, char, idx) => {
      acc[idx] = char.charCodeAt(0);
      return acc;
    }, new Uint8Array(data.length));

export const uint8ArrayToUrl = (data: Uint8Array) =>
  base64ToUrl(uint8ArrayToBase64(data));

export const urlToUint8Array = (data: string) =>
  base64ToUint8Array(urlToBase64(data));
